define('features/overlayGameLauncher/stats/shop/shopViewModel',[
    'knockout'
], function (ko) {

    return function ShopViewModel (newShop, parentView) {
        var self = this;

        self.id = 'shop';
        self.shopItems = newShop.shop.property('items');
        self.selectedShopItem = ko.observable(null);

        // self.shopItems.subscribe(function () {
        //     console.log('shopItems changed', arguments);
        // });

        self.viewSmall = 'features/overlayGameLauncher/stats/shop/shopViewSmall.html';
        self.viewLarge = 'features/overlayGameLauncher/stats/shop/shopViewLarge.html';

        self.changeViewToInventory = function () {
            // Maybe this could be moved as an event?
            parentView.changeCurrentScreenToById('gems');
        };

        self.buy = function (item) {
            item.cmd.dispatch(function () {
                self.changeViewToInventory();
            });
        };

        self.activate = function () {
            self.selectedShopItem(null);
        };

    };
});

